// Set up root reducer here
import { combineReducers } from 'redux';
import { firebaseStateReducer } from 'react-redux-firebase';
import { reducer as form } from 'redux-form';

import events from '../reducers/eventReducer';
import formPluginReducer from '../reducers/formPluginReducer';
import intl from '../reducers/intlReducer';
import polish from '../reducers/polishReducer';
import rooms from '../reducers/roomReducer';
import snackbars from '../reducers/snackbarReducer';
import users from '../reducers/userReducer';
import weather from '../reducers/weatherReducer';

const reducers = {
    events,
    firebase: firebaseStateReducer,
    form: form.plugin(formPluginReducer),
    intl,
    polish,
    rooms,
    snackbars,
    users,
    weather
};

export default combineReducers(reducers);


// WEBPACK FOOTER //
// ./src/store/rootReducer.js